import * as allExports from "@react-aria/overlays";
const { useOverlay, useOverlayPosition, useOverlayTrigger } = allExports;
export { useOverlay, useOverlayPosition, useOverlayTrigger };
//# sourceMappingURL=main.entry.mjs.mjs.map